import { makeVar, ReactiveVar } from "@apollo/client";
import { SportObjectsVars, sportObjectsVars } from "../sport-objects/sportObjects";

export enum SportEquipmentTabIdsEnum {
  ALL_EQUIPMENTS = "all_equipments",
  IS_ARCHIVED = "is_archived",
  IS_WROTE_OFF = "is_wrote_off",
}

export interface SportEquipmentTab {
  id: SportEquipmentTabIdsEnum;
  displayName: string;
};

export const SportEquipmentTabs: { [tab: string]: SportEquipmentTab } = {
  ALL_EQUIPMENTS: {
    id: SportEquipmentTabIdsEnum.ALL_EQUIPMENTS,
    displayName: "Оборудование на объектах"
  },
  IS_ARCHIVED: {
    id: SportEquipmentTabIdsEnum.IS_ARCHIVED,
    displayName: "Склад"
  },
  IS_WROTE_OFF: {
    id: SportEquipmentTabIdsEnum.IS_WROTE_OFF,
    displayName: "Списанное оборудование"
  }
};

export const sportEquipmentTabActiveVars = makeVar<SportEquipmentTab>(
  SportEquipmentTabs.ALL_EQUIPMENTS
);


export const useSportEquipmentTabActiveVars = () => createSportEquipmentTabActiveVars(sportEquipmentTabActiveVars);

const createSportEquipmentTabActiveVars = (sportEquipmentTabActiveVars: ReactiveVar<SportEquipmentTab>) => {
  const setTabActive = (tabActive: SportEquipmentTab) => {
    sportEquipmentTabActiveVars(tabActive);
  };

  return {
    setTabActive
  };
};